const initialState = {
    activeDropdown: null,
    activeMdDropdown:null
  };
  
  const dropdownReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'TOGGLE_DROPDOWN':
        return {
          ...state,
          activeDropdown: action.payload,
        };
      case 'TOGGLE_MD_DROPDOWN':
        return {
          ...state,
          activeMdDropdown: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default dropdownReducer;
  